import { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
// import Tables from "../../components/Tables";
import { Button, Col, Row } from "antd";
import styled from "styled-components";
import Title from "../../../components/Title";
import { BranchesOutlined, DownloadOutlined } from "@ant-design/icons";
import { TYPE_GET_DATE } from "../../../../helper/const";
import { exportExcel, getDateChangeTime, sortDataNatcom } from "../../../../helper/helper";
import DashboardPages from "../../../Dashboard/DashboardPages";
import FilterTime from "../../../components/FilterTime";
import _ from "lodash";
import DashboardOverview from "../../components/DashboardOverview";

export default function Overview({ handleGetData, tabActive, isMissCall = false }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));

  const { result = {} } =
    useSelector((state) => state.reducerNatcom?.data) || {};
  const { vm_digicel = [], vm_natcom = [] } = result;

  const datas = useMemo(() => {
    let quantity = [];
    let dataRevenue = [];

    if (vm_digicel) {
      for (const property in vm_digicel) {
        const itemQuantity = {
          type: "dataMarker",
          time: property,
          top: true,
          position: ["", 0],
          text: {
            content: "0",
          },
        };
        quantity = [...quantity, itemQuantity];
        const totalItem = _.last(vm_digicel[property]) || {};

        const item = {
          time: property,
          revenue: Number(totalItem.total_day),
          id: property,
        };
        dataRevenue = [...dataRevenue, item];
      }
    }

    let quantity_vm_natcom = [];
    let dataRevenue_vm_natcom = [];
    if (!_.isEmpty(vm_natcom)) {
      for (const property in vm_natcom) {
        const itemQuantity = {
          type: "dataMarker",
          time: property,
          top: true,
          position: ["", 0],
          text: {
            content: "0",
          },
        };
        quantity_vm_natcom = [...quantity_vm_natcom, itemQuantity];
        const totalItem = _.last(vm_natcom[property]) || {};

        const item = {
          time: property,
          revenue: Number(totalItem.total_day_0),
          id: property,
        };
        dataRevenue_vm_natcom = [...dataRevenue_vm_natcom, item];
      }
    }
    const revertDataQuantity = quantity.reverse();
    const revertDataRevenue = dataRevenue.reverse();

    const revertDataQuantity_vm_natcom = quantity_vm_natcom.reverse();
    const revertDataRevenue_vm_natcom = dataRevenue_vm_natcom.reverse();
    return {
      vm_digicel: {
        quantity:  revertDataQuantity,
        dataRevenue: revertDataRevenue,
      },

      vm_natcom: {
        quantity: revertDataQuantity_vm_natcom,
        dataRevenue: revertDataRevenue_vm_natcom,
      },
    };
  }, [vm_digicel, vm_natcom]);

  useEffect(() => {
    if (tabActive !== "1") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  let quantityRevenue = {
    data: sortDataNatcom(datas?.vm_digicel?.dataRevenue) || [],
    xField: "time",
    yField: ["revenue", "revenue"],
    annotations: {
      quantity: sortDataNatcom(datas?.vm_digicel?.quantity || []),
    },
  };

  let quantityRevenue_vm_natcom = {
    data: sortDataNatcom(datas?.vm_natcom?.dataRevenue || []),
    xField: "time",
    yField: ["revenue", "revenue"],
    annotations: {
      quantity: sortDataNatcom(datas?.vm_natcom?.quantity || []),
    },
  };

  const handleExportExcel = () => {
    let dataVmNatcom = [];
    for(const date in vm_natcom){
      const totalItem = _.last(vm_natcom[date]) || {};
      if(totalItem){
        dataVmNatcom.push(totalItem);
      }
    }
    dataVmNatcom = dataVmNatcom.sort((a, b) => new Date(b.date) - new Date(a.date)); 
    let dataVmDigicel = [];
    for(const date in vm_digicel){
      const totalItem = _.last(vm_digicel[date]) || {};
      if(totalItem){
        dataVmDigicel.push(totalItem);
      }
    }
    dataVmDigicel = dataVmDigicel.sort((a, b) => new Date(b.date) - new Date(a.date)); 
    let dataExport = [];
    for(const key in dataVmNatcom){
      if(dataVmNatcom[key].date === dataVmDigicel[key].date){
        dataExport.push({
          ...dataVmNatcom[key],
          qty_digicel: dataVmDigicel[key].qty_day,
          total_digicel: dataVmDigicel[key].total_day,
          time_digicel: dataVmDigicel[key].time_day,
        });
      }
    }
    dataExport = dataExport.sort((a, b) => new Date(b.date) - new Date(a.date));  
    exportExcel(dataExport, "vm_natcom")
  }
  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2 gap-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
        <div className="d-flex justify-content-end">
          <Button 
            onClick={handleExportExcel} 
            className="d-flex align-items-center"
          >
            <DownloadOutlined /> 
            Export Excel
          </Button>
        </div>
      </div>
      <Container className="panel panel-sortable">
        <Title titleName="Overview">
          <BranchesOutlined />
        </Title>
        <Col span={24}>
          <Col xs={24} lg={24} className="container-item">
          <div className="item-chart">
              {/* <DashboardPages dataDashboard={quantityRevenue} /> */}
              <h4 className="pt-3 pe-3 pb-5">Overview revenue chart VM:</h4>
              <DashboardOverview
                dataDashboard={quantityRevenue_vm_natcom}
                yField={"revenue"}
              />
            </div>
            <h4 className="pt-3 pe-3 pb-5">Overview revenue chart DIGICEL:</h4>
            <div className="item-chart">
              <DashboardOverview
                dataDashboard={quantityRevenue}
                yField={"revenue"}
              />
            </div>
            {/* <div className="item-chart">
              <h4 className="pt-3 pe-3 pb-5">Overview revenue chart VM:</h4>
              <DashboardOverview
                dataDashboard={quantityRevenue_vm_natcom}
                yField={"revenue"}
              />
            </div> */}
           
          </Col>
        </Col>
      </Container>
    </>
  );
}

const Container = styled(Row)``;
